import SortSelectInput from './SortSelectInput'

export default SortSelectInput
